import React, { useState } from 'react';
import Link from 'next/link';
import dayjs from 'dayjs';
import { CDN2 } from '@/helpers/api';
import Image from 'next/image';

export default function FAQCouponsPage({ discountApp, discountWeb }) {
  const [openIndex, setOpenIndex] = useState(null);

  const faqData = [
    {
      question: 'How can I find a valid On Air Parking coupon code?',
      answer: `We offer On Air Parking coupons for major airports across the U.S., often providing discounts of up to $${discountApp} off your airport parking. We frequently share new deals and offers, so be sure to subscribe to our email newsletter to receive the latest coupons straight to your inbox. Simply enter the code at checkout, and the discount will be applied.`,
    },
    {
      question: 'Can I use more than one coupon at a time?',
      answer: `You can use only one On Air Parking coupon code per booking, so be sure to select the one that gives you the best discount—whether it's a special offer from your email or an airport-specific coupon code.`,
    },
    {
      question: 'What is the best discount available for On Air Parking?',
      answer: `Our airport-specific parking coupons are always available—just enter your airport code at checkout to get up to $${discountApp} off your reservation. For even bigger savings, we also send out special offers when you subscribe to our newsletter. Keep an eye on your inbox for our best deals!`,
    },
    {
      question: 'What should I do if my coupon code does not work?',
      answer: `If your On Air Parking coupon isn't working, simply fill out our contact form, and our customer service team will assist you as quickly as possible.`,
    },
    {
      question: 'Do you offer discounts for AAA members?',
      answer: `We don't currently offer an AAA discount, but with our airport coupon codes and exclusive email offers, you'll always get the best possible price on your parking.`,
    },
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="w-full">
      <div className="space-y-4">
        {faqData.map((faq, index) => (
          <div key={index} className="border-b pb-2">
            <button
              onClick={() => toggleFAQ(index)}
              className="w-full flex justify-between items-center text-left font-semibold text-base md:text-lg"
            >
              <span>{faq.question}</span>
              <span className="text-gray-500">
                {openIndex === index ? '-' : '+'}
              </span>
            </button>
            {openIndex === index && (
              <p className="mt-2 text-gray-700">{faq.answer}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
